import { apiBaseUrl } from 'app/src/msw/companyagreement/api/apiBaseUrl'
import { getAllStaticProductsCollection } from 'app/src/msw/companyagreement/initialSeed/products'
import type { companyagreementApi } from 'app/src/services/welfareportal'
import { http, HttpResponse, type DefaultBodyType } from 'msw'

export const getProduct = http.get<{ productId: string }, DefaultBodyType, companyagreementApi.Product>(
  apiBaseUrl + '/products/:productId',
  async ({ params }) => {
    try {
      const jsonData = await getAllStaticProductsCollection()

      const product = jsonData.find((p) => p.productId === params.productId)

      console.log('getProduct jsonData', jsonData)
      return HttpResponse.json(product)
    } catch (error) {
      console.error('Error loading product:', error)
    }
  },
)
